export default "__VITE_ASSET__30edb07b__"